import { useTheme } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { format, parseISO, startOfHour } from "date-fns";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import CustomTooltip from "./CustomTooltip";
import Title from "./Title";
import api from "../../services/api";
import { toast } from "react-toastify";

const Chart = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  });

  const [chartData, setChartData] = useState([]);
  const [ticketsCount, setTicketsCount] = useState([]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchTicketsPorSetores = async () => {
        try {
          const initialChartData = Array.from(
            { length: 24 * 2 },
            (_, index) => {
              const hours = Math.floor(index / 2);
              const minutes = index % 2 === 0 ? "00" : "30";
              return {
                time: `${String(hours).padStart(2, "0")}:${minutes}`,
                amount: 0,
              };
            }
          );

          const { data } = await api.get("/tickets-por-dia", {
            params: {
              selectedDate,
            },
          });

          let somatorioPorDia = 0;
          const updatedChartData = initialChartData.map((dataPoint) => {
            const count = data.ticketsPorDia.filter((ticket) => {
              const ticketTime = format(
                startOfHour(parseISO(ticket.createdAt)),
                "HH:mm"
              );
              return ticketTime === dataPoint.time;
            }).length;

            somatorioPorDia = somatorioPorDia + count;
            return { ...dataPoint, amount: count };
          });

          setTicketsCount(somatorioPorDia);
          setChartData(updatedChartData);
        } catch (error) {
          toast.error("Erro ao carregar gráfico de Tickets por Dia!");
        }
      };

      fetchTicketsPorSetores();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [selectedDate]);

  return (
    <React.Fragment>
      <Title>{`Tickets por Dia: ${ticketsCount}`}</Title>
      <TextField
        label={t("dashboard.charts.date.title")}
        type="date"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        InputLabelProps={{
          shrink: true,
        }}
        style={{ marginBottom: "16px" }}
      />
      <ResponsiveContainer>
        <AreaChart
          data={chartData}
          barSize={40}
          width={730}
          height={300}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 0,
          }}
        >
          <XAxis
            dataKey="time"
            tickLine={false}
            axisLine={false}
            stroke={theme.palette.text.secondary}
          />
          <YAxis
            type="number"
            allowDecimals={false}
            stroke={theme.palette.text.secondary}
            tickLine={false}
            axisLine={false}
          />
          <CartesianGrid vertical={false} strokeDasharray="4" opacity={0.3} />
          <Tooltip content={<CustomTooltip />} cursor={true} />
          <Area
            type="monotone"
            dataKey="amount"
            stroke={theme.palette.primary.main}
            strokeWidth={2}
            fillOpacity={0.7}
            fill="#3f51b5"
            activeDot={{ r: 8 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};

export default Chart;
